import { getSimpleOrderTaskInfoFun } from "../../request/designapi/design/retailOrder/getSimpleOrderTaskInfo/post.js";
async function getSimpleOrderTaskInfo(params) {
  const pollingInterval = 6e3;
  const poll = async () => {
    const res = await getSimpleOrderTaskInfoFun(params);
    if (res.status) {
      const data = res.data;
      if (data) {
        const isFinished = data.finishedNum === data.total;
        const isStatus2WithRemark = String(data.status) === "2" && data.remark;
        if (isFinished || isStatus2WithRemark) {
          return res.data;
        }
      }
      await new Promise((resolve) => setTimeout(resolve, pollingInterval));
      return poll();
    } else {
      throw new Error(res.message);
    }
  };
  return poll();
}
export { getSimpleOrderTaskInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/kujiale/getSimpleOrderTaskInfo.js